import _parseInt from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-int";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import UserInfo from "@/components/userInfo/userInfo.vue";
import radarChart from "@/components/radarChart/radarChart.vue";
import ResetDone from "@/components/resetDone/resetDone.vue";
import getMyReport from "@/components/getMyReport/getMyReport.vue";
import EventBus from "@/utils/eventBus";
import GeneralUtilsHelper from "@/utils/generalUtils";
import BackTrack from "@/utils/backTrack";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { getLang } from '@/api/utils/apiHelper';

var EthnicityScanner =
/*#__PURE__*/
function (_Vue) {
  _inherits(EthnicityScanner, _Vue);

  function EthnicityScanner() {
    var _this;

    _classCallCheck(this, EthnicityScanner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EthnicityScanner).apply(this, arguments));
    _this.showVipRightNow = false;
    _this.userPic = "";
    _this.renderTime = 0;
    _this.radarDataList = [{
      text: "Caucasian",
      rate: 0,
      rateColor: "#F26C6A",
      key: "caucasian",
      percent: 0
    }, {
      text: "Black",
      rate: 0,
      rateColor: "#603BF3",
      key: "black",
      percent: 0
    }, {
      text: "Other",
      rate: 0,
      rateColor: "#F26C6A",
      key: "other",
      percent: 0
    }, {
      text: "Middle Eastern",
      rate: 0,
      rateColor: "#603BF3",
      key: "middleEastern",
      percent: 0
    }, {
      text: "Asian",
      rate: 0,
      rateColor: "#F26C6A",
      key: "asian",
      percent: 0
    }, {
      text: "Hispanic",
      rate: 0,
      rateColor: "#603BF3",
      key: "hispanic",
      percent: 0
    }];
    return _this;
  }

  _createClass(EthnicityScanner, [{
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
      this.removeBackTrack();
      this.removeRouterTempQuery();
      EventBus.$emit("isShowGetMyReport", {
        isShow: false
      });
    }
  }, {
    key: "removeRouterTempQuery",
    value: function removeRouterTempQuery() {
      routerTempHelpers.destroyTempQuery(this.$route.query);
    }
  }, {
    key: "rateUsFn",
    value: function () {
      var _rateUsFn = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var rateUsResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rateUs();

              case 2:
                rateUsResult = _context.sent;

                if (rateUsResult) {
                  this.isShowMask(true);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function rateUsFn() {
        return _rateUsFn.apply(this, arguments);
      }

      return rateUsFn;
    }()
  }, {
    key: "isShowMask",
    value: function isShowMask() {
      var _this2 = this;

      var rateUsChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showVipRightNow = this.$route.params.showVipRightNow;

      if (this.isVip || rateUsChange) {
        if (this.ethnicityScannerResult) {
          this.updateResultByName({
            name: "maskShow",
            result: false
          });
          EventBus.$emit("isShowGetMyReport", {
            isShow: false
          });
        } else {
          EventBus.$emit("isShowGetMyReport", {
            isShow: true,
            closeFn: this.clickClose,
            reportFn: this.gotoVip,
            color: true,
            title: this.$t("home_page.main_function_list.ethnicity_scanner"),
            titleColor: "#fff",
            headImg: this.userPic,
            animate: "Ethnicity",
            requestResult: this.syncGetResult,
            buttonStatus: "loading",
            loading_text: "Your future is waiting for you...👇"
          });
        }
      } else {
        EventBus.$emit("isShowGetMyReport", {
          isShow: true,
          closeFn: this.clickClose,
          reportFn: this.gotoVip,
          color: true,
          title: this.$t("home_page.main_function_list.ethnicity_scanner"),
          titleColor: "#fff",
          headImg: this.userPic,
          animate: "Ethnicity",
          rateUsFn: this.rateUsFn
        }); // 进来有params，回来没有

        if (this.showVipRightNow) {
          this.delayJumpToVip = setTimeout(function () {
            _this2.gotoVip("auto");
          }, this.delaySinglePageTime);
        }
      }
    }
  }, {
    key: "initData",
    value: function () {
      var _initData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var queryData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryData = routerTempHelpers.getQueryTemp(this.$route.query);
                this.userPic = queryData.imageData;
                this.syncGetResult = queryData.syncGetResult; // const data = JSON.parse(queryData.ethnicityData).data;
                // for (const item of this.radarDataList) {
                //   item.rate = parseInt(data[item.key]).toFixed(2) + "%";
                //   item.percent = data[item.key] / 100;
                // }
                // this.renderTime = new Date().valueOf();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  }, {
    key: "gotoVip",
    value: function gotoVip(params) {
      this.routerPush({
        name: "vipcenter",
        query: {
          type: "ethnicity",
          key: "ethnicity",
          byClick: !params
        },
        params: {
          routerTransition: params ? "static" : "up"
        }
      });
    }
  }, {
    key: "addedBackTrack",
    value: function addedBackTrack() {
      var _this3 = this;

      //增加安卓返回键：
      BackTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this3.clickClose();
        }
      });
    }
  }, {
    key: "removeBackTrack",
    value: function removeBackTrack() {
      BackTrack.destroy(this.$route.name);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.ethnicityScanner();
    }
  }, {
    key: "done",
    value: function done() {
      this.clickClose();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      // FaceClient.req_ethnicity()
      this.initData();
      this.isShowMask();
      this.addedBackTrack();
    } // private activated() {
    //   this.initData();
    //   this.isShowMask();
    // }

  }, {
    key: "destroyed",
    value: function destroyed() {
      this.delayJumpToVip && clearTimeout(this.delayJumpToVip);
    }
  }, {
    key: "isSpanis",
    get: function get() {
      return getLang() === "es";
    }
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "fr" || getLang() === "de" || getLang() === "it" || getLang().includes('zh');
    }
  }, {
    key: "ethnicityScannerResult",
    get: function get() {
      return this.getTempResultByName("ethnicityScanner");
    }
  }, {
    key: "resultList",
    get: function get() {
      var ethnicityResult = this.ethnicityScannerResult ? JSON.parse(this.ethnicityScannerResult).data : null;

      if (ethnicityResult) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(this.radarDataList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;
            item.rate = _parseInt(ethnicityResult[item.key]).toFixed(2) + "%";
            item.percent = ethnicityResult[item.key] / 100;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.renderTime = new Date().valueOf();
      }

      return this.radarDataList;
    }
  }, {
    key: "isVip",
    get: function get() {
      return GeneralUtilsHelper.isVip();
    } // @Watch("$route", { immediate: true })
    // private routerFrom(val: any, oldVal: any) {
    //   if (
    //     val.name === "ethnicityScanner" &&
    //     !this.isVip &&
    //     (!oldVal || (oldVal && oldVal.name !== "vipcenter"))
    //   ) {
    //     setTimeout(() => {
    //       this.delayJumpToVip = this.gotoVip("auto");
    //     }, 2000);
    //   }
    // }

  }, {
    key: "maskState",
    get: function get() {
      return this.getTempResultByName("maskShow");
    }
  }]);

  return EthnicityScanner;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], EthnicityScanner.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], EthnicityScanner.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.ETHNICITY_SCANNER)], EthnicityScanner.prototype, "ethnicityScanner", void 0);

tslib_1.__decorate([Getter(types.GETTER_TEMP_RESULT_BY_NAME)], EthnicityScanner.prototype, "getTempResultByName", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], EthnicityScanner.prototype, "updateResultByName", void 0);

tslib_1.__decorate([Action(types.RATE_US)], EthnicityScanner.prototype, "rateUs", void 0);

tslib_1.__decorate([Getter(types.GETTER_DELAY_SINGLE_PAGE_TIME)], EthnicityScanner.prototype, "delaySinglePageTime", void 0);

EthnicityScanner = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    UserInfo: UserInfo,
    radarChart: radarChart,
    ResetDone: ResetDone,
    getMyReport: getMyReport
  },
  name: "ethnicityScanner"
})], EthnicityScanner);
export default EthnicityScanner;